// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1tu6Q","content":"styles_content__7CvkA"};